<template>
    <div class="zsxx_h5">
      <TopTabs :list="this.$nav8"/>
      <div class="content" v-html="obj.content"></div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'

export default {
  name: 'Dtxx',
  components: { TopTabs },
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  created () {

  },
  mounted () {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .zsxx_h5 {
    width: 100vw;
    font-size: 3.7333vw;
    color: #333333;
    min-height: 200vw;

      .zsxx_content {

       display: flex;
       justify-content: space-between;
       border-bottom: 1px dashed #DBDBDB;
       margin-bottom: 3.2vw;
        padding: 0 4.2667vw;
        .zsxx_content_box {
          display: flex;

         .zsxx_content_yuan {
            width: 1.0667vw;
            height: 1.0667vw;
            background: #E88E0D;
            border-radius: 50%;
            margin-top: 2.1333vw;
            margin-right: 1.6vw;
          }
         .zsxx_content_text {
            padding-bottom: 8px;
            cursor: pointer;
            width: 64.6667vw;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .zsxx_content_time{
          color: #999999;
        }
      }
    }
</style>
